<div class="container">
  <div class="dialog-header">
    <p>{{ data.title }}</p>
    <div (click)="closeDialog()">
      <img src="assets/close-icon.svg">
    </div>
  </div>
  <input-text-field
    *ngIf="data.fieldType === 'name'"
    class="input-field"
    id="inputField"
    [group]="formGroup"
    [validators]="[Validators.required]"
    [floatingLabel]="nameLabel">
  </input-text-field>
  <mobile-number
    *ngIf="data.fieldType === 'mobile'"
    class="input-field"
    [group]="formGroup"
    [validators]="[Validators.required]"
    [floatingMobileLabel]="mobileNumberLabel"
    mobileNumberId="inputField">
  </mobile-number>
  <div class="input-field" *ngIf="data.fieldType === 'password'">
    <input-text-field
      class="input-field"
      id="oldPassword"
      [group]="formGroup"
      [inputType]="InputType.password"
      [validators]="[Validators.required]"
      [floatingLabel]="currentPasswordLabel">
    </input-text-field>
    <input-text-field
      class="input-field"
      id="newPassword"
      [group]="formGroup"
      [inputType]="InputType.password"
      [validators]="[Validators.required, Validators.min(8), validatePassword]"
      [floatingLabel]="createNewPasswordLabel">
    </input-text-field>
    <input-text-field
      class="input-field"
      id="confirmPassword"
      [group]="formGroup"
      [inputType]="InputType.password"
      [validators]="[Validators.required, Validators.min(8), validatePassword]"
      [floatingLabel]="confirmPasswordLabel">
    </input-text-field>
  </div>
  <div class="text-danger my-2" *ngIf="serverErrorMessage !== null">{{ serverErrorMessage }}</div>
  <primary-button
    class="submit-button"
    (onClick)="updateInfo()"
    [loading]="loading"
    [enabled]="formGroup.valid"
    title="{{submit}}">
  </primary-button>
</div>
